import type {
  LogisticsOrder,
  LogisticsOrderStatus,
  LogisticsOrderType,
} from '@/modules/logistics/types';

export type LogisticsOrderListFilters = {
  status?: LogisticsOrderStatus | 'all';
  type?: LogisticsOrderType | 'all';
  providerId?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
};

export function filterLogisticsOrders(
  orders: LogisticsOrder[],
  filters: LogisticsOrderListFilters,
): LogisticsOrder[] {
  let result = [...orders];

  if (filters.status && filters.status !== 'all') {
    result = result.filter((o) => o.status === filters.status);
  }
  if (filters.type && filters.type !== 'all') {
    result = result.filter((o) => o.type === filters.type);
  }
  if (filters.providerId) {
    result = result.filter((o) => o.providerId === filters.providerId);
  }
  if (filters.dateFrom) {
    result = result.filter((o) => o.scheduledDate >= filters.dateFrom!);
  }
  if (filters.dateTo) {
    result = result.filter((o) => o.scheduledDate <= filters.dateTo!);
  }
  const q = filters.search?.trim().toLowerCase();
  if (q) {
    result = result.filter(
      (o) =>
        o.address.toLowerCase().includes(q) ||
        o.contactName.toLowerCase().includes(q) ||
        o.notes.toLowerCase().includes(q),
    );
  }

  return result.sort((a, b) => a.scheduledDate.localeCompare(b.scheduledDate));
}
